import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add as AddIcon, AccountBalance as AccountBalanceIcon } from "@mui/icons-material";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import RegularButton from "components/CustomButtons/Button";
import AccountingAccountForm from "./AccountingAccountForm";
import { selectAccountingAccountTableData } from "./accountingAccountSelectors";
import columns from "./columns";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { useValidateReload } from "hooks/useValidateReload";
import {
  getAccountingAccountList, getSatGroupingCodesList, setAccountingAccountSearchFilters,
} from "redux/actions/accountingAccount/accountingAccountActions";
import { ACCOUNTING_ACCOUNT_LOADINGS } from "redux/reducers/accountingAccount/accountingAccountTypes";

const TABLE_KEY = "accountingAccount";
const LOADINGS = Object.values(ACCOUNTING_ACCOUNT_LOADINGS);

const AccountingAccountView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const {
    hasSearched, satGroupingCodesList, station,
  } = useSelector(({ accountingAccount }) => accountingAccount);
  const accountingAccountList = useSelector(selectAccountingAccountTableData);
  const isLoadingComp = useSelector(({ search }) => search.isLoadingComp);
  const [open, setOpen] = useToggle();

  const loading = isLoadingComp?.[ACCOUNTING_ACCOUNT_LOADINGS.GET_LIST] || false;

  useValidateReload(LOADINGS, getSatGroupingCodesList, satGroupingCodesList);

  const handleSearch = () => {
    if (!station) {
      setSnackbar("Seleccione una planta.", "warning");
      return;
    }
    dispatch(getAccountingAccountList(station.id));
  };

  const handleCreate = () => {
    if (!station) {
      setSnackbar("Seleccione una planta y busque las cuentas antes de crear una nueva.", "warning");
      return;
    }
    if (!hasSearched) {
      setSnackbar("Busque las cuentas de la planta antes de crear una nueva.", "warning");
      return;
    }
    setOpen();
  };

  return (
    <>
      <CardTable
        data={accountingAccountList}
        columns={columns}
        hasHeader
        blockBtn
        title="Cuenta Contable"
        icon={<AccountBalanceIcon />}
        isLoading={loading}
        noDataText={
          !station
            ? "Seleccione una planta y presione buscar"
            : "No hay cuentas contables registradas para esta planta"
        }
        tableContent={
          <TableInputs
            reducer={TABLE_KEY}
            stations
            dispatchAction={setAccountingAccountSearchFilters}
            loading={loading}
            submitAction={handleSearch}
            preventEvent
          />
        }
        tableKey={TABLE_KEY}
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={handleCreate}>
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      {open && <AccountingAccountForm setOpen={setOpen} open={open} />}
    </>
  );
};

export default AccountingAccountView;
